import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';

import { EmailField, PasswordField } from '#client/components/AccountFieldset';

import { useCheckout } from '../../../hooks/useCheckout';

function SummaryView({ sectionKey }) {
  const { formMethods } = useCheckout();
  const { getValues } = formMethods;

  // Get values from form context
  const { email, password } = getValues(sectionKey) || {};

  const sharedFieldProps = {
    disabled: true,
    readOnly: true,
    variant: 'standard',
    namePrefix: sectionKey
  };

  return (
    <Stack spacing={0}>
      <EmailField {...sharedFieldProps} value={email} />
      <PasswordField {...sharedFieldProps} value={password} />
    </Stack>
  );
}

SummaryView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default SummaryView;
